import styled from "styled-components";

export const Wrapper = styled.div`
  padding-bottom: 4px;
  max-height: 100vh;
  width: 240px;
  position: relative;
  background: #021128;
  color: #fff;

  .logo {
    padding: 12px 24px;
    display: flex;
    align-items: center;
    gap: 5.36px;
  }

  .top-section {
    height: calc(100vh - 228px);
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .image-with-dot {
    position: relative;

    .dot {
      position: absolute;
      z-index: 1;
      right: -3px;
      top: -3px;
      width: 6px;
      height: 6px;
      background: #fd0403;
      border-radius: 50%;
    }

    .green-dot {
      background: var(--success);
      width: 8px;
      height: 8px;
      right: 0;
      top: 0;
    }
  }

  .brands-header {
    font-weight: 450;
    font-size: 10px;
    line-height: 16px;
    letter-spacing: 1px;
  }

  @media screen and (max-width: 768px) {
    position: fixed;
    min-height: 100vh;
    left: -100%;
    top: 0;
    z-index: 23;
    transition: all 0.2s ease-out;

    &.open {
      width: 100%;
      left: 0;
    }
  }
`;

export const Brands = styled.div`
  padding: 12px 24px;
  position: sticky;
  top: 0;
  background-color: #021128;
  z-index: 3;

  .brands-dropdown {
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;

    .brand-name {
      font-size: 14px;
      font-weight: 700;
      line-height: 18px;
    }
  }

  .close-icon {
    float: right;
    margin-top: -25px;
    display: none;
  }

  @media screen and (max-width: 768px) {
    .close-icon {
      display: block;
    }
  }
`;

export const ArrowWrapper = styled.button`
  width: 20px;
  height: 20px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    cursor: pointer;
    background: #031f48;
  }
`;

export const Menu = styled.div`
  margin: 24px 0 90px;
  color: #cccccc;
  padding: 0 12px;

  .dropdown-li {
    margin-bottom: 24px;
  }

  .icon {
    width: 16px;
  }

  li a {
    padding: 12px 14px;
    border-radius: 6px;
    text-decoration: none;
    display: block;
    font-weight: 450;
    font-size: 14px;
    line-height: 18px;
    &:hover {
      background: rgba(3, 31, 72, 0.9);
      color: #fff;
      .icon {
        filter: brightness(150%);
      }
    }
  }

  .linkGroup {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .active {
    background: rgba(3, 31, 72, 0.9);
    color: #fff;
    font-weight: 700;
    .icon {
      filter: brightness(150%);
    }
  }
`;

export const BottomSection = styled.div`
  position: absolute;
  height: 220px;
  bottom: 0;
  left: 0;
  width: 100%;
  border-top: 1px solid var(--grey_10);
  background-color: #021128;
  z-index: 3;

  .workspace-header {
    padding-left: 24px;
    font-weight: 450;
    font-size: 10px;
    line-height: 16px;
    letter-spacing: 1px;
  }
`;

export const WorkspaceContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 10px;
  padding-left: 24px;
  cursor: pointer;

  .arrow-icon {
    transform: rotate(270deg);
  }

  .wrapper {
    max-width: 25px;
  }

  .workspaces .wrapper:nth-child(2){
    z-index: -1;
  }
  .workspaces .wrapper:nth-child(3){
    z-index: -2;
  }
  .workspaces .wrapper:nth-child(4){
    z-index: -3;
  }


  .workspaces .wrapper:nth-child(2) .imgWrapper {
    background: var(--secondary);
  }
  .workspaces .wrapper:nth-child(3) .imgWrapper {
    background: var(--warning);
  }
  .workspaces .wrapper:nth-child(4) .imgWrapper {
    background: var(--success);
  }

  .workspace {
    width: 32px;
    height: 32px;
    background: #032250;
    border-radius: 50%;
    font-weight: 450;
    font-size: 12px;
  }
`;

export const WorkspaceMenu = styled.div`
  padding: 0 12px;
  color: #cccccc;

  .icon {
    width: 16px;
  }

  .menu-list a {
    padding: 12px 14px;
    border-radius: 6px;
    text-decoration: none;
    display: block;
    font-weight: 450;
    font-size: 14px;
    line-height: 18px;
    &:hover {
      background: rgba(3, 31, 72, 0.9);
      color: #fff;
      .icon {
        filter: brightness(150%);
      }
    }
  }

  .linkGroup {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .active {
    background: rgba(3, 31, 72, 0.9);
    color: #fff;
    font-weight: 700 !important;
    .icon {
      filter: brightness(150%);
    }
  }
`;
